import { useCallback, useEffect } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import QuestionBox from '../../../question-box';
import Task301Game from './game';

type Props = {
    onComplete?: () => void
}

const Task301: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-301');

    useEffect(() => {
        onComplete();
    }, [onComplete])

    return <div className="task task-301">
        <h2>zadanie 1</h2>
        <h3>{task?.title}</h3>
        <p>
            Książki pozwalają podróżować w czasie! Dzięki Asiuni możemy dowiedzieć się jak wyglądało życie podczas II wojny światowej, a Dzieci z Bullerbyn opowiadają o wiosce w Szwecji w I połowie XX w. Jesteście ciekawi, co działo się kiedyś w Waszej okolicy?
        </p>
        <p className="instruction">
            <strong>Zadanie:</strong> Wylosujcie datę, klikając przycisk “Losuj” poniżej, i dowiedzcie się, jakie wydarzenia miały wtedy miejsce u Was. Na pewno pomogą Wam w tym archiwalne wydania lokalnych gazet w Waszej bibliotece!
        </p>
        <Task301Game />
        <QuestionBox>
            <p>
                A co wtedy działo się w całej Polsce, Europie i na świecie? Spróbujcie to ustalić!
            </p>
        </QuestionBox>
        <p>
            Jeśli interesuje Was praca archiwistów i chcecie o niej dowiedzieć się więcej, zagrajcie w{'\u00A0'}grę{'\u00A0'}<a href="https://szkolatolerancji.ceo.org.pl/rememory-multimedialne-historie-lokalne/gra/" target="_blank" rel="noreferrer"><strong>Re:Memory</strong></a>!
        </p>
    </div>
}

export default Task301;
